import React from 'react';
import { Avatar } from 'antd';

const UserAvatar = ({
  name,
  single = true,
  avatarOnly = false,
  loading,
  containerClass,
  avatarSize,
  src,
  icon,
  ...rest
}) => {
  return (
    <div
      className={`c-avatar d-flex flex-${single ? 'row' : 'column'} align-items-center justify-content-center ${
        containerClass ? containerClass : ''
      }`}
    >
      <div className={`avatar-collection ${avatarOnly ? 'avatar-only' : ''}`.trim()}>
        <div className="d-inline-block">
          <Avatar size={avatarSize || 30} {...(src ? { src } : {})} icon={icon && icon} {...rest} />
        </div>
      </div>
    </div>
  );
};

export default UserAvatar;
